import { sendGet, sendPost, sendPut } from "api/restUtil";
import {useEffect, useMemo, useState} from 'react';
import DatePickerInput from "components/input/DatePickerInput";
import TimeInput from "components/input/TimeInput";
import BasicButton from "components/button/BasicButton";
import { getDateToIsoDate, isEmpty, isValidDate } from "js/common";
import { checkAndRemoveInvalid, checkRequiredAndInvalid, makeRequireColumns } from "js/requireCheck";

// 상품 주문 배치 강제 실행
function OrderSchedForce() {

	const formId = "orderSchedForceForm";

	// 데이터
	const [ data, setData ] = useState({});
	
	const handleDataChange = (e) => {
		const {name, value} = e.target;
		let d = {...data};
		d[name] = value;

		setData(d);
	}

	// 실행
	const forceSchedule = async () => {

		const preSelector = "#" + formId;
		const requiredColumns = ["fromDt", "fromTm", "toDt", "toTm"];
		if(!checkRequiredAndInvalid(makeRequireColumns(requiredColumns), data, preSelector)) return;
		if(!isValidDate(data.fromDt) || !isValidDate(data.toDt)) {
			alert("날짜를 정확히 입력해 주세요.");
			return;
		}

		const tmpData = {};

		let lastChangedFrom = data.fromDt + " " + data.fromTm;
		lastChangedFrom = getDateToIsoDate(lastChangedFrom);
		
		let lastChangedTo = data.toDt + " " + data.toTm + ":59.999";
		lastChangedTo = getDateToIsoDate(lastChangedTo);

		tmpData.lastChangedFrom = lastChangedFrom;
		tmpData.lastChangedTo = lastChangedTo;

		if(!window.confirm("실행 하시겠습니까")) return;

		const result = await sendPost("/api/scheduler-force/product-order", tmpData);
		if(result.respCode === "SUCCESS") {
			alert("성공했습니다.");
			return;
		}
	}


	// 데이터 변경 시 invalid 제거 처리
	useEffect(() => {
		checkAndRemoveInvalid(data, "#" + formId);
	}, [data]);

	return (
		<div className="ant-tabs-tabpane">
			
			<div id={formId} style={{textAlign: "left"}}>
				<div style={{width: "500px", display: "flex"}}>
					<div style={{width: "30%"}}>
						<DatePickerInput name={"fromDt"} value={data?.fromDt ?? ""} onChange={handleDataChange} />
					</div>
					<div style={{width: "19%"}}>
						<TimeInput name={"fromTm"} value={data?.fromTm ?? ""} onChange={handleDataChange}  />
					</div>
					~
					<div style={{width: "30%"}}>
						<DatePickerInput name={"toDt"} value={data?.toDt ?? ""} onChange={handleDataChange} />
					</div>
					<div style={{width: "19%"}}>
						<TimeInput name={"toTm"} value={data?.toTm ?? ""} onChange={handleDataChange}  />
					</div>
				</div>
				<span className="burgundy">※ 최대 간격은 24시간입니다. 초과시 오류 발생.</span>

				
				<div className="me-modal-footer mg-t-10 mg-b-20" style={{width: "500px"}}>
					<div className="table-buttons" >
						<BasicButton label="실행" className="btn-save" onClick={forceSchedule} />

					</div>
				</div>
			</div>

		</div>
	);
}

export default OrderSchedForce;